/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DepartmentCreate
 */
export interface DepartmentCreate {
    /**
     * 
     * @type {string}
     * @memberof DepartmentCreate
     */
    label: string;
}

/**
 * Check if a given object implements the DepartmentCreate interface.
 */
export function instanceOfDepartmentCreate(value: object): value is DepartmentCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function DepartmentCreateFromJSON(json: any): DepartmentCreate {
    return DepartmentCreateFromJSONTyped(json, false);
}

export function DepartmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DepartmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function DepartmentCreateToJSON(json: any): DepartmentCreate {
    return DepartmentCreateToJSONTyped(json, false);
}

export function DepartmentCreateToJSONTyped(value?: DepartmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

